export default __webpack_public_path__ + "static/media/logo.eb8a46bb.png";